export const colors = {
  primary: {
    blue: { value: "#003899" }, // Primary Blue
    green: { value: "#00927B" }, // Primary Green (brand)
    black: { value: "#1D1D1F" }, // Primary Black
    white: { value: "#FFFFFF" }, // Primary White
  },

  // Green palette based on #00927B and #D1FAE5 (50–900)
  green: {
    50: { value: "#F0FDF9" }, // Lightest
    100: { value: "#D1FAE5" }, // Light (e.g. subtle backgrounds)
    200: { value: "#9FD6CE" },
    300: { value: "#6EE7B7" },
    400: { value: "#34D399" },
    500: { value: "#00927B" }, // Base / brand green
    600: { value: "#007D66" },
    700: { value: "#006352" },
    800: { value: "#004D40" },
    900: { value: "#003D33" }, // Darkest
  },

  secondary: {
    green: { value: "#00B373" }, // Secondary Green
    blue: { value: "#496CF6" }, // Secondary Blue
    red: { value: "#E64545" }, // Secondary Red
    yellow: { value: "#D8CA00" }, // Secondary Yellow
  },

  tertiary: {
    lightGreen: { value: "#69D2AD" }, // Tertiary Light Green
    lightBlue: { value: "#7BA9FF" }, // Tertiary Light Blue
    lightRed: { value: "#FF7F76" }, // Tertiary Light Red
    lightYellow: { value: "#F8E700" }, // Tertiary Light Yellow
  },

  blue: {
    900: { value: "#022157" }, // #022157 - Primary Blue (Darkest)
    800: { value: "#0047B3" }, // #0047B3
    700: { value: "#0056CC" }, // #0056CC
    600: { value: "#0066E6" }, // #0066E6
    500: { value: "#496CF6" }, // #496CF6 - Secondary Blue
    400: { value: "#7BA9FF" }, // #7BA9FF - Tertiary Light Blue
    300: { value: "#A3C7FF" }, // #A3C7FF
    200: { value: "#D7EDFF" }, // #D7EDFF
    100: { value: "#EBF5FF" }, // #EBF5FF
    50: { value: "#F5FAFF" }, // #F5FAFF (Lightest)
  },

  gray: {
    900: { value: "#3C3C3C" }, // #3C3C3C
    800: { value: "#6D6D6D" }, // #6D6D6D
    700: { value: "#666666" }, // #7E7E7E
    600: { value: "#9CA3AF" }, // #9CA3AF
    400: { value: "#CCCCCC" }, // #CCCCCC
    200: { value: "#E5E7EB" }, // #E5E7EB
    100: { value: "#F5F5F5" }, // #F5F5F5
  },

  status: {
    success: { value: "#00B373" }, // Success Green
    error: { value: "#E64545" }, // Error Red
    warning: { value: "#D8CA00" }, // Warning Yellow
    info: { value: "#003899" }, // Info Blue
  },
};
